// @ts-strict-ignore
import { useTranslation } from "react-i18next";

import { l } from "@shared/locales/i18n";

import * as styles from "./CircleLoader.styles";

enum CircleLoaderType {
  NULL,
  INLINE,
}

interface Props {
  type?: CircleLoaderType;
}

const CircleLoader = (props: Props) => {
  const { t } = useTranslation();

  return (
    <div
      role="progressbar"
      aria-label={t(l.sharedCommon.Loading)}
      aria-valuetext={t(l.sharedCommon.Loading)}
      css={styles.circleLoader}
      className={CircleLoaderType[props.type]}
    />
  );
};

export { CircleLoader };
